import React from "react";
import * as R from "ramda";
import { Div } from "components/Base";
import { connect } from "react-redux";
// import { isEmptyOrNil } from "utils/General";
import styleSpects from "components/Base/Base/styleSpecs";
import { noop } from "utils/General";
import * as PortalUserSelectors from "redux/modules/portal/user/selectors";
import * as PortalSelectors from "redux/modules/portal/selectors";
import * as PortalUserActions from "redux/modules/portal/user/actions";

import MenuPopover from "./MenuPopover";

const decorate = connect(
  state => ({
    accounts: PortalUserSelectors.accounts(state),
    portalUser: PortalUserSelectors.portalUser(state),
    portal: PortalSelectors.portal(state)
  }),
  {
    updatePortalUser: PortalUserActions.updatePortalUser
  }
);

const MenuItem = ({ rightIcon = "", children, onClick = noop }) => (
  <Div
    fs={2}
    px={3}
    py={2}
    onClick={onClick}
    display="row.flex-start.center"
    bg={{
      hover: "neutral0",
      default: "white"
    }}
    color="gray7"
    style={{ cursor: "pointer" }}
  >
    {rightIcon ? (
      <Div display="row.space-between.center" flex={1}>
        {children}
        <i
          className={`material-icons-outlined check`}
          style={{ color: "#4263EB", fontSize: styleSpects.fontSize[2] }}
        >
          check
        </i>
      </Div>
    ) : (
      children
    )}
  </Div>
);

const ProfileDropdown = ({
  accounts = [],
  portalUser,
  updatePortalUser = noop,
  portal = {}
}) => {
  const accountsToShow = R.filter(
    a => a.id !== R.path(["active_view", "id"], portalUser),
    accounts
  );

  const updateActiveView = activeViewId => {
    updatePortalUser({
      eventId: portal.event.id,
      userId: portalUser.user_id,
      activeView: activeViewId
    }).then(() => {
      window.location = `/portals/${portal.event.slug}/${portal.event.uuid}`;
    });
  };

  return (
    <MenuPopover
      anchorOrigin={{
        vertical: "top",
        horizontal: "left"
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right"
      }}
      Label={
        <Div
          fs={2}
          px={3}
          py={2}
          display="row.space-between.center"
          bg={{
            hover: "neutral0",
            default: "white"
          }}
          color="gray7"
        >
          <Div display="row.flex-start.center">
            <Div display="row.flex-start.center" width={14} mr={2}>
              <i
                className={`material-icons-outlined`}
                style={{ color: "#494949", fontSize: styleSpects.fontSize[2] }}
              >
                pages
              </i>
            </Div>
            Switch Portals
          </Div>
          <Div display="row.flex-start.center">
            <i
              className={`material-icons-outlined`}
              style={{ color: "#494949", fontSize: styleSpects.fontSize[4] }}
            >
              chevron_right
            </i>
          </Div>
        </Div>
      }
    >
      {({ closePopover }) => (
        <Div bra={3} bg="white" width={200} py={2}>
          {portalUser.user_id !== portalUser.active_view.id && (
            <MenuItem
              key={portalUser.user_id}
              {...(portalUser.active_view.id === portalUser.user_id && {
                rightIcon: "check"
              })}
              onClick={() => {
                updateActiveView(portalUser.user_id);
                closePopover();
              }}
            >
              <Div
                display="column.flex-start.flex-start"
                styles={{ gap: "2px" }}
              >
                <Div color="gray7" fs={2} fw={4} lineHeight="18.20px">
                  {`${portalUser.user_fname} ${portalUser.user_lname}`}
                </Div>
                <Div color="gray5" fs={1} uppercase>
                  Portal User
                </Div>
              </Div>
            </MenuItem>
          )}
          {R.map(
            ({ id, name, record_type = "Account" }) => (
              <MenuItem
                key={id}
                {...(portalUser.active_view.id === id && {
                  rightIcon: "check"
                })}
                onClick={() => {
                  updateActiveView(id);
                  closePopover();
                }}
              >
                <Div
                  display="column.flex-start.flex-start"
                  styles={{ gap: "2px" }}
                >
                  <Div color="gray7" fs={2} fw={4} lineHeight="18.20px">
                    {name}
                  </Div>
                  <Div color="gray5" fs={1} uppercase>
                    {record_type}
                  </Div>
                </Div>
              </MenuItem>
            ),
            accountsToShow
          )}
        </Div>
      )}
    </MenuPopover>
  );
};

export default decorate(ProfileDropdown);
